import request from '@/utils/request'

// ========== 认证 ==========
export const login = (data) => request.post('/auth/login', data)
export const logout = () => request.post('/auth/logout')
export const register = (data) => request.post('/auth/register', data)
export const getCaptcha = () => request.get('/auth/captcha')
export const getRegions = (params) => request.get('/auth/regions', { params })
export const changePassword = (data) => request.post('/auth/change-password', data)
export const createAccount = (data) => request.post('/auth/create-account', data)
export const getProfile = () => request.get('/auth/profile')
export const updateProfile = (data) => request.put('/auth/profile', data)
export const getUserList = (params) => request.get('/auth/users', { params })
export const toggleUserStatus = (id, data) => request.put(`/auth/users/${id}/status`, data)
export const updateUser = (id, data) => request.put(`/auth/users/${id}`, data)
export const resetUserPassword = (id, data) => request.post(`/auth/users/${id}/reset-password`, data)

// ========== 仪表盘 ==========
export const getDashboardSummary = () => request.get('/dashboard/summary')
export const getSalesChart = () => request.get('/dashboard/sales-chart')
export const getRoleStats = () => request.get('/dashboard/role-stats')
export const getRecentOrders = () => request.get('/dashboard/recent-orders')

// ========== 代理管理 ==========
export const getAgentTree = () => request.get('/agent/tree')
export const getMyTeam = () => request.get('/agent/team')
export const getTeamMember = (id) => request.get(`/agent/team/${id}/detail`)
export const getMyCommission = (params) => request.get('/agent/commission', { params })
export const getAgentCommission = (id, params) => request.get(`/agent/commission/${id}`, { params })
export const getMyCustomers = (params) => request.get('/agent/customer', { params })
export const getAllCustomers = () => request.get('/agent/customer/all')
export const addCustomer = (data) => request.post('/agent/customer', data)
export const getMyWallet = () => request.get('/agent/wallet')
export const getWalletTransactions = (params) => request.get('/agent/wallet/transactions', { params })
export const exchangePoints = (data) => request.post('/agent/points/exchange', data)
export const rechargeAgent = (id, data) => request.post(`/agent/${id}/recharge`, data)


export const getSalesReport = (params) => request.get('/agent/sales-report', { params })

// ========== 订单管理 ==========
export const createOrder = (data) => request.post('/order/create', data)
export const payOrder = (id) => request.put(`/order/pay/${id}`)
export const getMyOrders = (params) => request.get('/order/my-orders', { params })
export const getOrderDetail = (id) => request.get(`/order/${id}`)
export const cancelOrder = (id) => request.put(`/order/${id}/cancel`)
export const getOrderStats = () => request.get('/order/statistics')

// ========== 发货管理 ==========
export const getPendingOrders = (params) => request.get('/shipping/pending', { params })
export const shipOrder = (data) => request.post('/shipping/ship', data)
export const batchShip = (data) => request.post('/shipping/batch-ship', data)
export const trackOrder = (id) => request.get(`/shipping/track/${id}`)
export const completeOrder = (id) => request.put(`/shipping/complete/${id}`)
export const getWarehouses = () => request.get('/shipping/warehouses')
export const createWarehouse = (data) => request.post('/shipping/warehouses', data)
export const updateWarehouse = (id, data) => request.put(`/shipping/warehouses/${id}`, data)
export const getWarehouseInventory = (id) => request.get(`/shipping/warehouses/${id}/inventory`)
export const stockIn = (id, data) => request.post(`/shipping/warehouses/${id}/stock-in`, data)
export const getInventoryLogs = (id, params) => request.get(`/shipping/warehouses/${id}/inventory-logs`, { params })

// ========== 公告管理 ==========
export const createAnnouncement = (data) => request.post('/notice/create', data)
export const updateAnnouncement = (id, data) => request.put(`/notice/${id}`, data)
export const getMyNotices = () => request.get('/notice/my-notices')
export const getUnreadCount = () => request.get('/notice/unread-count')
export const getUserNotices = (params) => request.get('/notice/user-notices', { params })
export const markAsRead = (id) => request.post(`/notice/${id}/read`)
export const batchMarkRead = (data) => request.post('/notice/batch-read', data)
export const getAllAnnouncements = (params) => request.get('/notice/all', { params })
export const deleteAnnouncement = (id) => request.delete(`/notice/${id}`)
export const toggleTop = (id) => request.put(`/notice/${id}/top`)

// ========== 商品管理 ==========
export const getProductList = (params) => request.get('/product/list', { params })
export const getAllProducts = () => request.get('/product/all')
export const getProductDetail = (id) => request.get(`/product/${id}`)
export const createProduct = (data) => request.post('/product/create', data)
export const updateProduct = (id, data) => request.put(`/product/${id}`, data)
export const deleteProduct = (id) => request.delete(`/product/${id}`)
export const purchaseProduct = (id, data) => request.post(`/product/${id}/purchase`, data)

// ========== 聊天室 ==========
export const getChatMessages = (params) => request.get('/chat/', { params })
export const sendChatMessage = (data) => request.post('/chat/', data)

// ========== 代理留言 ==========
export const getMessageInbox = () => request.get('/message/inbox')
export const getMessageSent = () => request.get('/message/sent')
export const getAllMessages = () => request.get('/message/')
export const sendMessage = (data) => request.post('/message/', data)
export const markMessageRead = (id) => request.put(`/message/${id}/read`)
export const replyMessage = (id, data) => request.post(`/message/${id}/reply`, data)
export const getMessageUnreadCount = () => request.get('/message/unread-count')
export const getMessageReceivers = () => request.get('/message/receivers')

// ========== 管理员积分规则 ==========
export const getPointsRules = () => request.get('/admin/points-rules')
export const updatePointsRules = (data) => request.put('/admin/points-rules', data)

// ========== 管理员推广积分规则 ==========
export const getReferralPointsRules = () => request.get('/admin/referral-points-rules')
export const updateReferralPointsRules = (data) => request.put('/admin/referral-points-rules', data)

// ========== 系统设置 ==========
export const getSetting = (key) => request.get(`/admin/settings/${key}`)
export const updateSetting = (key, data) => request.put(`/admin/settings/${key}`, data)

// ========== 装机软件 ==========
export const getToolList = () => request.get('/tools/')
export const createTool = (data) => request.post('/tools/', data)
export const updateTool = (id, data) => request.put(`/tools/${id}`, data)
export const deleteTool = (id) => request.delete(`/tools/${id}`)

// ========== JWT 刷新 ==========
export const refreshToken = () => request.post('/auth/refresh')

// ========== 数据导出 ==========
export const exportOrders = (params) => request.get('/export/orders', { params, responseType: 'blob' })
export const exportSalesReport = (params) => request.get('/export/sales-report', { params, responseType: 'blob' })

// ========== 操作审计日志 ==========
export const getAuditLogs = (params) => request.get('/audit/logs', { params })
export const cleanupAuditLogs = () => request.post('/audit/cleanup')

// ========== CSV 批量导入发货 ==========
export const csvImportShip = (formData) => request.post('/shipping/csv-import', formData)

// ========== 装机知识 ==========
export const getKnowledgeList = (params) => request.get('/knowledge/', { params })
export const getKnowledgeDetail = (id) => request.get(`/knowledge/${id}`)
export const createKnowledge = (data) => request.post('/knowledge/', data)
export const updateKnowledge = (id, data) => request.put(`/knowledge/${id}`, data)
export const deleteKnowledge = (id) => request.delete(`/knowledge/${id}`)

// ========== 商品素材 ==========
export const getMaterialList = (params) => request.get('/material/', { params })
export const getMaterialDetail = (id) => request.get(`/material/${id}`)
export const createMaterial = (data) => request.post('/material/', data)
export const updateMaterial = (id, data) => request.put(`/material/${id}`, data)
export const deleteMaterial = (id) => request.delete(`/material/${id}`)

// ========== 官方联络 ==========
export const getMyContact = () => request.get('/contact/my-contact')
// 管理员管理QQ号
export const getQQList = (params) => request.get('/contact/qq', { params })
export const createQQ = (data) => request.post('/contact/qq', data)
export const updateQQ = (id, data) => request.put(`/contact/qq/${id}`, data)
export const deleteQQ = (id) => request.delete(`/contact/qq/${id}`)
// 管理员管理微信号
export const getWechatList = (params) => request.get('/contact/wechat', { params })
export const createWechat = (data) => request.post('/contact/wechat', data)
export const updateWechat = (id, data) => request.put(`/contact/wechat/${id}`, data)
export const deleteWechat = (id) => request.delete(`/contact/wechat/${id}`)
// 管理员管理QQ群
export const getGroupList = (params) => request.get('/contact/group', { params })
export const createGroup = (data) => request.post('/contact/group', data)
export const updateGroup = (id, data) => request.put(`/contact/group/${id}`, data)
export const deleteGroup = (id) => request.delete(`/contact/group/${id}`)
// 管理员搜索代理
export const searchAgents = (params) => request.get('/contact/search-agents', { params })

// ========== 下级管理员 ==========
export const getSubAdmins = (params) => request.get('/admin/sub-admins', { params })
export const createSubAdmin = (data) => request.post('/admin/sub-admins', data)
export const updateSubAdmin = (id, data) => request.put(`/admin/sub-admins/${id}`, data)
export const resetSubAdminPassword = (id, data) => request.post(`/admin/sub-admins/${id}/reset-password`, data)
export const deleteSubAdmin = (id) => request.delete(`/admin/sub-admins/${id}`)

// ========== 推广链接 & 下级管理 ==========
export const getMyReferralCode = () => request.get('/referral/my-code')
export const regenerateReferralCode = () => request.post('/referral/regenerate-code')
export const getReferralDownline = (params) => request.get('/referral/my-downline', { params })
export const getTeamAll = (params) => request.get('/referral/my-team-all', { params })
export const getReferralStats = () => request.get('/referral/stats')
export const checkInviteCode = (code) => request.get(`/referral/check/${code}`)
export const recordVisit = (code) => request.get(`/referral/visit/${code}`)
export const getReferralPoints = (params) => request.get('/referral/my-points', { params })

// ========== 积分管理 ==========
export const getMyPoints = (params) => request.get('/agent/points', { params })

// ========== 任务/奖励中心 ==========
export const getMyTasks = (params) => request.get('/task/my-tasks', { params })
export const claimTaskReward = (id) => request.post(`/task/claim/${id}`)
export const getTaskTemplates = () => request.get('/task/admin/templates')
export const createTaskTemplate = (data) => request.post('/task/admin/templates', data)
export const updateTaskTemplate = (id, data) => request.put(`/task/admin/templates/${id}`, data)
export const toggleTaskTemplate = (id) => request.put(`/task/admin/templates/${id}/toggle`)
export const deleteTaskTemplate = (id) => request.delete(`/task/admin/templates/${id}`)

// ========== 客户跟进记录 ==========
export const getFollowUps = (params) => request.get('/followup/', { params })
export const getUpcomingFollowUps = (params) => request.get('/followup/upcoming', { params })
export const getCustomerFollowUps = (id) => request.get(`/followup/customer/${id}`)
export const createFollowUp = (data) => request.post('/followup/', data)
export const updateFollowUp = (id, data) => request.put(`/followup/${id}`, data)
export const deleteFollowUp = (id) => request.delete(`/followup/${id}`)
export const getFollowUpStats = () => request.get('/followup/stats')

// ========== 消息中心 ==========
export const getNotifications = (params) => request.get('/notify/list', { params })
export const getNotifyUnreadCount = () => request.get('/notify/unread-count')
export const markNotifyRead = (id) => request.post(`/notify/${id}/read`)
export const markAllNotifyRead = () => request.post('/notify/read-all')
export const deleteNotification = (id) => request.delete(`/notify/${id}`)
export const clearAllNotifications = () => request.post('/notify/clear')
export const adminSendNotify = (data) => request.post('/notify/admin/send', data)

// ========== 广告信息管理 ==========
// 原广告管理 (banner 图片广告)
export const getAdList = (type = 'banner') => request.get('/admin/ads', { params: { type } })
// 滚动广告管理 (marquee 首页滚动)
export const getMarqueeAdList = () => request.get('/admin/ads', { params: { type: 'marquee' } })
// 获取公开启用的滚动广告（首页用）
export const getPublicAds = () => request.get('/admin/ads/active', { params: { type: 'marquee' } })
// 获取公开启用的 banner 广告（首页用）
export const getBannerAds = () => request.get('/admin/ads/active', { params: { type: 'banner' } })
export const createAd = (data) => request.post('/admin/ads', data)
export const updateAd = (id, data) => request.put(`/admin/ads/${id}`, data)
export const deleteAd = (id) => request.delete(`/admin/ads/${id}`)

// ========== 数据库备份 ==========
export const getBackupSettings = () => request.get('/admin/database-backup/settings')
export const updateBackupSettings = (data) => request.put('/admin/database-backup/settings', data)
export const getBackupList = () => request.get('/admin/database-backup/list')
export const createBackup = () => request.post('/admin/database-backup/backup')
export const downloadBackup = (filename) => request.get(`/admin/database-backup/download/${encodeURIComponent(filename)}`, { responseType: 'blob' })
export const restoreBackup = (filename) => request.post(`/admin/database-backup/restore/${encodeURIComponent(filename)}`)
export const deleteBackup = (filename) => request.delete(`/admin/database-backup/delete/${encodeURIComponent(filename)}`)

// ========== 创业扶持 ==========
export const submitApplication = (data) => request.post('/entrepreneurship/apply', data)
export const getMyApplications = (params) => request.get('/entrepreneurship/my-applications', { params })
export const getMyApplicationDetail = (id) => request.get(`/entrepreneurship/my-applications/${id}`)
export const getAdminApplications = (params) => request.get('/entrepreneurship/admin/list', { params })
export const getAdminApplicationDetail = (id) => request.get(`/entrepreneurship/admin/list/${id}`)
export const replyApplication = (id, data) => request.post(`/entrepreneurship/admin/list/${id}/reply`, data)
export const exportApplications = (params) => request.get('/entrepreneurship/admin/export', { params, responseType: 'blob' })
